import { render } from "./footer.vue?vue&type=template&id=d873d46c&scoped=true"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=d873d46c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d873d46c"]])

export default __exports__